module.exports = __webpack_public_path__ + "static/img/PRC2018.5c50603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PRC2018.jpg
// module id = 9veA
// module chunks = 1